import { SearchOutlined, CheckOutlined } from '@ant-design/icons';
import { Button, Input, Spin, Select, message } from 'antd';
import { billingSelectors, workSpaceSelectors } from 'containers/App/selectors';
import { checkBill, getResultImport, importInvoice } from 'pages/BillingProcess/thunk';
import { Wrapp } from 'pages/BillingProcessRegister/RegisterFirstStep/styles';
import { FC, useEffect, useMemo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from 'types/store';
import { ConsultationStatus, Pagination } from 'components';
import { hospital_visit_and_links_results } from 'types';
import TableReceive from './Table';
import Wrap from './styles';
import {
  getFacilityByUser,
  getHospitals,
  registerBillReceive,
  updateBillingData,
  updateStatusOfClinic,
} from './thunks';

const date = new Date();
const defaultOptionInvoice = [
  {
    name: `${date.getFullYear() - (date.getMonth() === 0 ? 1 : 0)}年${
      date.getMonth() === 0 ? 12 : date.getMonth()
    }月度`,
    value: `${date.getFullYear() - (date.getMonth() === 0 ? 1 : 0)}${
      date.getMonth() > 0 && date.getMonth() < 10
        ? '0' + date.getMonth().toString()
        : date.getMonth() === 0
        ? 12
        : date.getMonth()
    }`,
  },
  {
    name: `${date.getFullYear()}年${date.getMonth() + 1}月度`,
    value: `${date.getFullYear()}${
      date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1).toString() : date.getMonth() + 1
    }`,
  },
];

const RegisterReceivingStatus: FC = () => {
  const dispatch = useDispatch();
  const { facility, invoiceH, field_edit, hospitals, fieldHospital } = useSelector(
    (state: RootState) => state.receivingSlice,
  );
  const { userInfo } = useSelector(workSpaceSelectors);
  const { optionInvoice } = useSelector(billingSelectors);
  const [invoiceMonth, setInvoiceMonth] = useState<string>('');
  const [isH1, setIsH1] = useState(true);
  const [loadH2, setLoadH2] = useState(false);
  const [isSearchData, setIsSearchData] = useState(false);
  const [valueSearch, setValueSearch] = useState('');
  const [page, setPage] = useState(1);
  const [listUpdate, setListUpdate] = useState<hospital_visit_and_links_results[]>([]);
  const [saveOK, setSaveOK] = useState(false);

  const hospitalVisitOption = useMemo(() => {
    const result = fieldHospital?.find(([_key, value]: [string, any]) => value.display_id === 'hospital_visit');
    if (!result) {
      return [];
    }
    return result[1].options;
  }, [fieldHospital]);

  useEffect(() => {
    if (userInfo) {
      dispatch(getFacilityByUser(userInfo.user_groups[0].group_id));
    }
  }, [dispatch, userInfo]);

  useEffect(() => {
    const date = new Date();
    const dateNewFormat = [
      `${date.getFullYear()}${date.getMonth() < 10 ? '0' + date.getMonth().toString() : date.getMonth()}`,
      `${date.getFullYear()}${date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1).toString() : date.getMonth() + 1}`,
    ];
    if (facility) {
      dispatch(checkBill({ facility_id: facility?.i_id || '', invoice_month: dateNewFormat }));
    }
  }, [facility, dispatch]);

  useEffect(() => {
    if (invoiceMonth && facility) {
      dispatch(
        getHospitals({
          invoice_month: invoiceMonth,
          facility_id: facility?.i_id ?? '',
          facilityId: facility?.facility_name ?? '',
          valueSearch: '',
          page: 1,
          per_page: 50,
        }),
      );
    }
  }, [dispatch, invoiceH, facility, invoiceMonth]);

  const LoadHospitalVisit = async () => {
    const dataBill: any = await dispatch(
      registerBillReceive({
        facility_id: facility?.i_id || '',
        invoice_month: invoiceMonth,
        facility_name: facility?.facility_name ?? '',
      }),
    );
    if (!dataBill.payload) {
      return;
    }

    if (dataBill.payload.item && dataBill.payload.item?.Status !== '請求書作成中') {
      setIsH1(false);
      dispatch(
        getHospitals({
          invoice_month: invoiceMonth,
          facility_id: facility?.i_id ?? '',
          facilityId: facility?.facility_name ?? '',
          valueSearch: '',
          page: 1,
          per_page: 50,
        }),
      );
      return;
    }

    setLoadH2(true);
    const result: any = await dispatch(
      importInvoice({
        facility_id: facility?.i_id || '',
        invoice_month: invoiceMonth,

        facilityId: facility?.facility_id || '',
      }),
    );
    if (!result.payload || result.payload.result) {
      dispatch(
        getHospitals({
          invoice_month: invoiceMonth,
          facility_id: facility?.i_id ?? '',
          facilityId: facility?.facility_name ?? '',
          valueSearch: '',
          page: 1,
          per_page: 50,
        }),
      );
      setLoadH2(false);
      setIsH1(false);
    } else if (result.payload.error) {
      message.error('データインポート中にエラーが発生しました。処理を中断し、システム管理会社にご連絡ください。', 5);
      dispatch(
        getHospitals({
          invoice_month: invoiceMonth,
          facility_id: facility?.i_id ?? '',
          facilityId: facility?.facility_name ?? '',
          valueSearch: '',
          page: 1,
          per_page: 50,
        }),
      );
      setLoadH2(false);
      setIsH1(false);
    } else {
      const getStatusImport = async (stream_id: string) => {
        const resultImport: any = await dispatch(
          getResultImport({
            stream_id: stream_id,
          }),
        );
        const obj = resultImport ? resultImport.payload : null;
        if (obj) {
          const status = obj[Object.keys(obj)[0]].status;

          if (status.id === 0 || status.id === 1) {
            setTimeout(() => getStatusImport(stream_id), 5000);
          } else if (status.id === 2) {
            dispatch(
              getHospitals({
                invoice_month: invoiceMonth,
                facility_id: facility?.i_id ?? '',
                facilityId: facility?.facility_name ?? '',
                valueSearch: '',
                page: 1,
                per_page: 50,
              }),
            );
            setLoadH2(false);
            setIsH1(false);
          } else {
            message.error(
              'データインポート中にエラーが発生しました。処理を中断し、システム管理会社にご連絡ください。',
              5,
            );
            dispatch(
              getHospitals({
                invoice_month: invoiceMonth,
                facility_id: facility?.i_id ?? '',
                facilityId: facility?.facility_name ?? '',
                valueSearch: '',
                page: 1,
                per_page: 50,
              }),
            );
            setLoadH2(false);
            setIsH1(false);
          }
        }
      };
      getStatusImport(result.payload.stream_id);
    }
  };

  const statusEdit = field_edit.find((f) => f.value === invoiceH?.editing_status_by_clinic);

  const contentText = () => {
    const updateStatusClinic = () => {
      dispatch(
        updateStatusOfClinic({
          i_id: invoiceH?.i_id,
        }),
      );
      setPage(1);
      setValueSearch('');
    };

    if (invoiceH?.Status === '請求書作成中') {
      if ((statusEdit ? statusEdit.display_id : invoiceH?.editing_status_by_clinic) === 'o_editing') {
        return (
          <>
            <div className="tutorial">
              <span className="standardBoldFont">受診状況を○✖を選択して保存してください。</span>
              <span className="standardBoldFont">
                入力が完了しましたら、翌月5日までに右の「入力完了報告する」ボタンをクリックし完了してください。
              </span>
              <span className="standardBoldFont"> 報告後、内容に変更がありましたら直接ご連絡ください。️</span>
            </div>
            <Button onClick={updateStatusClinic} className="standardBoldFont btn-report">
              入力完了報告する
            </Button>
          </>
        );
      }
      if ((statusEdit ? statusEdit.display_id : invoiceH?.editing_status_by_clinic) === 'o_end') {
        return (
          <div className="tutorial">
            <span className="standardBoldFont">入力完了報告が終わっています。</span>
            <span className="standardBoldFont">内容に変更がありましたら直接ご連絡ください。</span>
          </div>
        );
      }
    }
    return (
      <>
        <span className="standardBoldFont">修正・変更がある場合は、直接ご連絡ください。</span>
      </>
    );
  };

  const handleChangeSearch = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (isSearchData) {
      setIsSearchData(false);
    }
    setValueSearch(e.target.value);
  };

  const searchData = () => {
    setIsSearchData(!!valueSearch);
    dispatch(
      getHospitals({
        invoice_month: invoiceMonth,
        facility_id: facility?.i_id ?? '',
        facilityId: facility?.facility_name ?? '',
        valueSearch: valueSearch,
        page: 1,
        per_page: 50,
      }),
    );
  };
  const handleChangePage = (page: number) => {
    setPage(page);
    dispatch(
      getHospitals({
        invoice_month: invoiceMonth,
        facility_id: facility?.i_id ?? '',
        facilityId: facility?.facility_name ?? '',
        valueSearch: isSearchData ? valueSearch : '',
        page: page,
        per_page: 50,
      }),
    );
  };
  const handleReset = () => {
    setPage(page);
    setValueSearch('');
    dispatch(
      getHospitals({
        invoice_month: invoiceMonth,
        facility_id: facility?.i_id ?? '',
        facilityId: facility?.facility_name ?? '',
        valueSearch: '',
        page: 1,
        per_page: 50,
      }),
    );
  };

  const updateBillData = async () => {
    const response: any = await dispatch(
      updateBillingData({
        i_id: invoiceH?.i_id ?? '',
        hospitals: listUpdate,
        listOption: hospitalVisitOption,
      }),
    );
    if (response) {
      setSaveOK(true);
    }
    setTimeout(() => {
      setSaveOK(false);
    }, 4000);
  };

  const changeUpdate = (item: hospital_visit_and_links_results, hospital: string, isUpdate: boolean) => {
    if (!isUpdate) {
      return;
    }
    const data = [...listUpdate];
    const index = listUpdate.findIndex((f) => f.i_id === item.i_id);

    if (index > -1) {
      data.splice(index, 1, { ...item, hospital_visit: hospital });

      setListUpdate(data);
    } else {
      setListUpdate((oldState) => [...oldState, { ...item, hospital_visit: hospital }]);
    }
  };

  const changeInvoiceMonth = (e: any) => {
    setInvoiceMonth(e);
  };

  return (
    <Wrap>
      <ConsultationStatus
        facility_name={facility?.facility_name ?? ''}
        defaultOptionInvoice={defaultOptionInvoice}
        invoice_month={invoiceMonth}
        changeInvoiceMonth={changeInvoiceMonth}
        loadHospital={LoadHospitalVisit}
      />
      {isH1 ? (
        <Spin spinning={loadH2} size="large">
          <Wrapp>
            <div className="section">
              <div>作成・編集を行う請求月度を選択し開始ボタンをクリックしてください。</div>
              <Select style={{ width: '20%' }} value={invoiceMonth} onChange={changeInvoiceMonth}>
                {optionInvoice.length > 0
                  ? optionInvoice.map((op) => (
                      <Select.Option value={op.value}>{op.name.slice(0, op.name.length - 1)}</Select.Option>
                    ))
                  : defaultOptionInvoice.map((opd) => <Select.Option value={opd.value}>{opd.name}</Select.Option>)}
              </Select>
              <Button disabled={!invoiceMonth} id="btn-small" className="btn-save-step" onClick={LoadHospitalVisit}>
                開始
              </Button>
            </div>
          </Wrapp>
        </Spin>
      ) : (
        <Spin spinning={loadH2} size="large">
          <div className="report">{contentText()}</div>
          <div className="search">
            <span style={{ marginRight: 10 }}>
              <SearchOutlined />
            </span>
            <Input
              size={'large'}
              name="search"
              value={valueSearch}
              onChange={handleChangeSearch}
              style={{ width: '305px' }}
              className="standardFont"
              placeholder="ご利用者名で検索"
            />
            <Button size={'large'} onClick={searchData} className="btn-search">
              検索
            </Button>
            <Button size={'large'} onClick={handleReset} className="btn-clear">
              クリア
            </Button>
          </div>
          <div className="table">
            <TableReceive dataUpdate={listUpdate} onChangeData={changeUpdate} />
          </div>
          <div className="pagination">
            <Pagination page={page} per_page={50} totalItems={hospitals.totalItems} onChangePage={handleChangePage} />
          </div>
          <div className="save">
            {invoiceH?.Status === '請求書作成中' &&
              (statusEdit ? statusEdit.display_id : invoiceH?.editing_status_by_clinic) !== 'o_end' && (
                <Button
                  onClick={updateBillData}
                  className={(saveOK ? 'save-ok' : 'save-default') + ' btn-save extraLargeFont'}
                >
                  {saveOK ? (
                    <>
                      <CheckOutlined /> 保存しました
                    </>
                  ) : (
                    'このページの入力内容を保存する'
                  )}
                </Button>
              )}
          </div>
        </Spin>
      )}
    </Wrap>
  );
};
export default RegisterReceivingStatus;
